/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable-line react/forbid-prop-types */
import React from "react"
import Head from "next/head"
import Layout from "components/Layout"
import TextPage from "components/Mobile/TextPage"
import { Box, Typography } from "@material-ui/core"

const AboutUsPage = () => (
  <Layout>
    <Head>
      <title>Contatti</title>
    </Head>
    <TextPage
      pageTitle="Contatti"
      pageContent={
        <Box mt={3} mb={20} px={1}>
          <Typography variant="body1">
            Per qualsiasi informazione puoi scriverci a <a href="mailto:info@badtraveller.com">info@badtraveller.com</a>
          </Typography>
        </Box>
      }
    />
  </Layout>
)

export default AboutUsPage
